import { object, string } from "yup";

export const personalTaxUserInviteValidationSchema = object({
  first_name: string().required("First name is required"),
  last_name: string().required("Last name is required"),
  email: string().required("Email is required").email("Invalid email"),
  parent_group_id: string().required("Parent group is required"),
});
